// extracted by mini-css-extract-plugin
export default {"productDescription":"Afa-z","featuredDescription":"Bfa-z","description":"Cfa-z","more":"Dfa-z","descriptionSku":"Efa-z"};